export const APP_NAME = 'Ratnakar Securities';
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'ratnakar_access_token',
  REFRESH_TOKEN: 'ratnakar_refresh_token',
  THEME: 'theme',
  USER_DATA: 'ratnakar_user_data'
};

export const ROLES = {
  ADMIN: 'admin',
  USER: 'user'
};
